import { configureStore } from "@reduxjs/toolkit";
import pageReducer from "./pageSlicer"

export const store = configureStore({
    reducer: {
        open: pageReducer,
    },
})
